import "./App.css";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import LinkSection from "./components/LinkSection";
import MainSection from "./components/MainSection";
import ProjectSection from "./components/ProjectSection";
import ThemeSection from "./components/ThemeSection";
import ToolbarNav from "./components/ToolbarNav";
import { ErrorBoundary } from "./components/ErrorBoundary";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <ToolbarNav />
        <ThemeSection />
        <MainSection />
        <AboutSection />
        <ProjectSection />
        <LinkSection />
        <Footer />
      </ErrorBoundary>
    </div>
  );
}

export default App;
